import React from 'react';
import { Modal, Typography } from 'antd';
import { ReactComponent as Logo } from 'static/inons_large/upsl_logo.svg';
import aLeague from 'static/divisions/a_league.png';
import academyDivision from 'static/divisions/academy_division.png';
import division1 from 'static/divisions/division_1.png';
import premier from 'static/divisions/premier.png';
import upslWoman from 'static/divisions/upsl_women.png';
import './style.scss';

export const SiteBranding = ({ isTouched, lang }: { isTouched?: boolean; lang?: 'es' | 'en' }) => {
  const onExit = (e: any) => {
    if (isTouched) {
      e.preventDefault();
      Modal.confirm({
        title:
          lang !== 'en'
            ? 'Si abandonas esta página perderás todo tu progreso'
            : 'If you leave this page, you will lose all your progress',
        content:
          lang !== 'en'
            ? '¿Estás seguro de que quieres salir de esta página?'
            : 'Are you sure you want to leave this page?',
        cancelText: lang !== 'en' ? 'Sí' : 'Leave Page',
        okText: lang !== 'en' ? 'No' : 'Continue Registration',
        className: 'model-confirmation',
        icon: null,
        onCancel: () => {
          const { href } = e.target.closest('a');
          if (href) window.location.href = href;
        },
      });
    }
  };

  return (
    <div className="site-branding">
      <a href="https://premier.upsl.com/" title="Back to Homepage" onClick={onExit}>
        <Logo className="upsl-logo" />
      </a>
      <div className="other-divisions">
        <Typography.Paragraph>United Premier Soccer League divisions: </Typography.Paragraph>
        <div className="other-divisions__list">
          <img src={premier} alt="" />
          <img src={division1} alt="" />
          <img src={aLeague} alt="" />
          <img src={academyDivision} alt="" />
          <img className="upsl-woman" src={upslWoman} alt="" />
        </div>
      </div>
    </div>
  );
};
